import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-forest-dark text-center" data-id="element-165" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white" data-id="element-166" data-mp="3gfitoga0y7d2">
        © Mountain Bike Coach Ready 2026 — All Rights Reserved.
      </p>
      <p className="text-xs text-white/70 mt-2" data-id="element-167" data-mp="32p5nojgp12qd">
        Digital coaching material for mountain bike coaches. Results depend on how the system
        is applied in your coaching sessions.
      </p>
    </footer>;
}